module.exports = __webpack_public_path__ + "img/Model.868e1df5.svg";